import t from "@/lang/lang";
import {
  DocumentState,
  DocumentStateBase,
} from "@/services/backend/documents/types/state";

/**
 * isImmutable returns whether the document was written down and must not be
 * changed anymore.
 */
export function isImmutable(document: DocumentStateBase): boolean {
  return document.state === DocumentState.Immutable;
}

/**
 * isReady returns whether the document is complete and may be handed to the
 * customer. A written down document is ready as well.
 */
export function isReady(document: DocumentStateBase): boolean {
  return (
    document.state === DocumentState.Ready ||
    document.state === DocumentState.Immutable
  );
}

/** isDraft returns whether the document is still a draft. */
export function isDraft(document: DocumentStateBase): boolean {
  return document.state === DocumentState.Draft;
}

/** documentStateLabel returns the label of the state, as shown to users. */
export function documentStateLabel(state: DocumentState): string {
  switch (state) {
    case DocumentState.Draft:
      return t("Entwurf");
    case DocumentState.Ready:
      return t("Bereit");
    case DocumentState.Immutable:
      return t("Festgeschrieben");
    default:
      return state;
  }
}

/**
 * documentStateActionLabel returns the label of the transition into the
 * state, as shown to users. It names the action, not the state: a user
 * writes a document down ("Festschreiben"), the document then is written
 * down ("Festgeschrieben"), see [documentStateLabel].
 */
export function documentStateActionLabel(state: DocumentState): string {
  switch (state) {
    case DocumentState.Draft:
      return t("Als Entwurf markieren");
    case DocumentState.Ready:
      return t("Als bereit markieren");
    case DocumentState.Immutable:
      return t("Festschreiben");
    default:
      return state;
  }
}
